import React, { useState, useRef } from 'react';
import Barcode from 'react-barcode';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const defaultBarcodeOptions = {
  value: 'Toolover',
  fontOptions: 'bold',
  font: "fantasy",
  textAlign: "center",
  textPosition: "bottom",
  textMargin: 25,
  fontSize: 40,
  background: "#ffffff",
  lineColor: "#334155",
  // marginLeft: 30,
  // marginTop: 50,
  format: "CODE128",
  flat: false,
  width: 2,
  height: 100,
  displayValue: true
}

const inactiveButtonStyle = "px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 focus:z-10 focus:ring-2  dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white"
const activeButtonStyle = "px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-gray-200 focus:z-10 focus:ring-2 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white"

const BarcodeGenerator = () => {
  const [barcodeOptions, setBarcodeOptions] = useState(defaultBarcodeOptions)
  const [error, setError] = useState(null);

  const handleOptionChange = (e) => {
    setBarcodeOptions({ ...barcodeOptions, [e.target.name]: e.target.value })
  }
  const handleOnTextAlignChange = (e) => {
    setBarcodeOptions({ ...barcodeOptions, textAlign: e.target.value })
  }

  const handleOnTextPositionChange = (e) => {
    setBarcodeOptions({ ...barcodeOptions, textPosition: e.target.value })
  }

  const handleDownload = () => {
    const svg = document.getElementById('barcodeElement');
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svg);

    // Create a Blob for the SVG
    const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    // Create a temporary link to download the image
    const link = document.createElement('a');
    link.href = url;
    link.download = `${barcodeOptions.value}.svg`
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const renderBarcode = () => {
    try {
      // Try rendering the Barcode component
      if (barcodeOptions.value) {
        return (
          <div className='text-center'>
            <Barcode id="barcodeElement" className='block mt-4' {...barcodeOptions} />
            <button
              className="text-white mt-4 bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
              onClick={handleDownload}
            >
              <FontAwesomeIcon
                style={{ width: '18px' }}
                icon={faDownload}
              />
              {` `}&nbsp; Download
            </button>
            </div>
        )
      } else {
        throw new Error("Barcode value is missing.");
      }
    } catch (err) {
      console.log(err)
      // Catch any errors from rendering
      setError(err.message);
      return null;
    }
  };

  return (
    <div className="grid grid-cols-1 xl:grid-cols-1 xl:gap-4">
      <div className="grid grid-cols-2 bg-white p-4 mb-4 space-y-6 border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
        <div className='col-span-1'>
          <div className="px-4 tex py-2 text-gray-400 rounded dark:border-gray-600">
            <label for="countries" className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Input Text</label>
            <input
              type="text"
              value={barcodeOptions.value}
              onChange={handleOptionChange}
              name='value'
              className="bg-gray-50 border w-full border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required={true}
              placeholder='Enter your text here'
            />
            <label className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Bar width ({barcodeOptions.width})</label>
            <input min={2} max={10} onChange={handleOptionChange} name='width' type="range" value={barcodeOptions.width} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"></input>
            
            <label className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Bar height ({barcodeOptions.height})</label>
            <input min={50} max={200} onChange={handleOptionChange} name='height' type="range" value={barcodeOptions.height} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"></input>
            
            <label for="countries" className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Format</label>
            <select
              value={barcodeOptions.format}
              onChange={handleOptionChange}
              name='format'
              className="bg-gray-50 border w-full border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value="CODE128">CODE128 auto</option>
              <option value="CODE128A">CODE128 A</option>
              <option value="CODE128B">CODE128 B</option>
              <option value="CODE128C">CODE128 C</option>
              <option value="EAN13">EAN13</option>
              <option value="EAN8">EAN8</option>
              <option value="UPC">UPC</option>
              <option value="CODE39">CODE39</option>
              <option value="ITF14">ITF14</option>
              <option value="ITF">ITF</option>
              <option value="MSI">MSI</option>
              <option value="MSI10">MSI10</option>
              <option value="MSI11">MSI11</option>
              <option value="MSI1010">MSI1010</option>
              <option value="MSI1110">MSI1110</option>
              <option value="pharmacode">Pharmacode</option>
            </select>
            <label for="countries" className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Background</label>
            <input type="color" onChange={handleOptionChange} name="background" value={barcodeOptions.background}></input>

            <label for="countries" className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Line Color</label>
            <input type="color" onChange={handleOptionChange} name="lineColor" value={barcodeOptions.lineColor}></input>
            <div className="flex items-center mt-4">
              <input
                checked={barcodeOptions.displayValue}
                onChange={() => setBarcodeOptions({ ...barcodeOptions, displayValue: !barcodeOptions.displayValue })}
                name='displayValue'
                id="checked-checkbox-2" type="checkbox"
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
              <label for="checked-checkbox-2" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Display Text</label>
            </div>
            { barcodeOptions.displayValue && (
              <>
                  <label className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Font Weight</label>
                  <select
                    value={barcodeOptions.fontOptions}
                    onChange={handleOptionChange}
                    name='fontOptions'
                    className="bg-gray-50 border w-full border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option value="bold" style={{ fontWeight: 'bold' }}>Bold</option>
                    <option value="normal" style={{ fontWeight: 'normal' }}>Normal</option>
                    <option value="italic" style={{ fontStyle: 'italic' }}>Italic</option>
                  </select>
                  <label for="countries" className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Font</label>
                  <select
                    value={barcodeOptions.font}
                    onChange={handleOptionChange}
                    name='font'
                    className="bg-gray-50 border w-full border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option value="monospace" style={{ fontFamily: 'monospace' }}>Monospace</option>
                    <option value="sans-serif" style={{ fontFamily: 'sans-serif' }}>Sans-serif</option>
                    <option value="serif" style={{ fontFamily: 'serif' }}>Serif</option>
                    <option value="fantasy" style={{ fontFamily: 'fantasy' }}>Fantasy</option>
                    <option value="cursive" style={{ fontFamily: 'cursive' }}>Cursive</option>
                  </select>
                  <label className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Text Alignment</label>
                  <div class="inline-flex rounded-md shadow-sm" role="group">
                    <button onClick={handleOnTextAlignChange} value='left' type="button" className={ barcodeOptions.textAlign === 'left' ? activeButtonStyle : inactiveButtonStyle } >
                      Left
                    </button>
                    <button onClick={handleOnTextAlignChange} value='center' type="button" className={ barcodeOptions.textAlign === 'center' ? activeButtonStyle : inactiveButtonStyle }>
                      Center
                    </button>
                    <button onClick={handleOnTextAlignChange} value='right' type="button" className={ barcodeOptions.textAlign === 'right' ? activeButtonStyle : inactiveButtonStyle }>
                      Right
                    </button>
                  </div>
                  <label className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Text Position</label>
                  <div class="inline-flex rounded-md shadow-sm" role="group">
                    <button onClick={handleOnTextPositionChange} value='top' type="button" className={ barcodeOptions.textPosition === 'top' ? activeButtonStyle : inactiveButtonStyle } >
                      Top
                    </button>
                    <button onClick={handleOnTextPositionChange} value='bottom' type="button" className={ barcodeOptions.textPosition === 'bottom' ? activeButtonStyle : inactiveButtonStyle }>
                      Bottom
                    </button>
                  </div>
                  <label className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Font Size ({barcodeOptions.fontSize})</label>
                  <input onChange={handleOptionChange} name='fontSize' type="range" value={barcodeOptions.fontSize} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"></input>
                  <label className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Text Margin ({barcodeOptions.textMargin})</label>
                  <input onChange={handleOptionChange} name='textMargin' type="range" value={barcodeOptions.textMargin} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"></input>
                </>
              )}
          </div>
        </div>
        <div className='col-span-1 flex justify-center items-center'>
          {error ? (
            <p className="text-red-500">Error: {error}</p>
          ) : (
            renderBarcode()
          )}
        </div>
      </div>
    </div>
  )
}

export default BarcodeGenerator;
